import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateEvaluationTestDialog } from './CreateEvaluationTestDialog';

export const CreateEvaluationTestPage = () => {
  const navigate = useNavigate();
  const [isDialogOpen] = useState(true);

  const handleClose = () => {
    navigate('/opinions/evaluation');
  };

  const handleSuccess = (testId: string) => {
    navigate(`/opinions/evaluation/${testId}/run`);
  };

  return (
    <CreateEvaluationTestDialog
      isOpen={isDialogOpen}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  );
};
